/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whole numbers from -999,999,999,999 to 999,999,999,999. Decimals aren't converted — round or split them first.`)
};

const es_nw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Números enteros de -999,999,999,999 a 999,999,999,999. Los decimales no se convierten — redondea o divídelos primero.`)
};

const de_nw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganze Zahlen von -999,999,999,999 bis 999,999,999,999. Dezimalzahlen werden nicht umgewandelt — runden oder teilen Sie sie zuerst.`)
};

const nl_nw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hele getallen van -999.999.999.999 tot 999.999.999.999. Decimalen worden niet geconverteerd — rond ze eerst af of splits ze.`)
};

const fr_nw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombres entiers de -999 999 999 999 à 999 999 999 999. Les décimales ne sont pas converties — arrondissez ou divisez-les d'abord.`)
};

const it_nw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numeri interi da -999,999,999,999 a 999,999,999,999. I decimali non vengono convertiti — arrotonda o dividili prima.`)
};

const pt_br2_nw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Números inteiros de -999.999.999.999 a 999.999.999.999. Decimais não são convertidos — arredonde ou divida-os primeiro.`)
};

const pt_nw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Números inteiros de -999.999.999.999 a 999.999.999.999. Os números decimais não são convertidos — arredonde ou divida-os primeiro.`)
};

const ja_nw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`−999,999,999,999から999,999,999,999までの整数。小数は変換されません。先に四捨五入または分割してください。`)
};

const zh_nw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从 -999,999,999,999 到 999,999,999,999 的整数。不支持小数——请先四舍五入或拆分。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nw_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nw_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nw_faq1_a", locale)
	if (locale === "en") return en_nw_faq1_a(inputs)
	if (locale === "es") return es_nw_faq1_a(inputs)
	if (locale === "de") return de_nw_faq1_a(inputs)
	if (locale === "nl") return nl_nw_faq1_a(inputs)
	if (locale === "fr") return fr_nw_faq1_a(inputs)
	if (locale === "it") return it_nw_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_nw_faq1_a(inputs)
	if (locale === "pt") return pt_nw_faq1_a(inputs)
	if (locale === "ja") return ja_nw_faq1_a(inputs)
	return zh_nw_faq1_a(inputs)
};